import { render, staticRenderFns } from "./PortalHeader.vue?vue&type=template&id=d51e236a&scoped=true&"
import script from "./PortalHeader.vue?vue&type=script&lang=js&"
export * from "./PortalHeader.vue?vue&type=script&lang=js&"
import style0 from "./PortalHeader.vue?vue&type=style&index=0&id=d51e236a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d51e236a",
  null
  
)

export default component.exports